import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayUnstructured'
})
export class ArrayUnstructuredPipe implements PipeTransform {

  transform = (arr: any[], value: { [key: number]: any[] }) => {
    const response: any[] = arr;

    const orderValue = Object.keys(value).sort((a, b) => +b - +a);

    orderValue.forEach((item) => response.splice(+item, 0, ...value[item]));

    return response;
  }

}
